import React from 'react';

const formatCurrency = (value) => `S/ ${(Number(value) || 0).toFixed(2)}`;

const ConvenioPrestamoModal = ({
  show,
  onClose,
  selectedPrestamo,
  convenioForm,
  errors = {},
  totals,
  handleInputChange,
  handleConfirmAction
}) => {
  if (!show || !selectedPrestamo) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-panel modal-panel-lg p-6">
        <header className="mb-4 flex flex-col gap-1">
          <h3 className="modal-title">
            Convenio del Prestamo #{selectedPrestamo.idPrestamo}
          </h3>
          <p className="modal-text">
            Monto original: {formatCurrency(selectedPrestamo.monto)} | Frecuencia actual:{' '}
            {selectedPrestamo.frecuencia?.toUpperCase() || 'N/D'}
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-3 mb-4">
          <div className="p-3 rounded-lg bg-gray-50 border">
            <p className="text-xs text-gray-500">Capital/Interes pendiente</p>
            <p className="text-lg font-semibold text-slate-900">{formatCurrency(totals?.basePendiente)}</p>
          </div>
          <div className="p-3 rounded-lg bg-gray-50 border">
            <p className="text-xs text-gray-500">Mora incluida</p>
            <p className="text-lg font-semibold text-gray-900">{formatCurrency(totals?.moraPendiente)}</p>
          </div>
          <div className="p-3 rounded-lg bg-gray-50 border">
            <p className="text-xs text-gray-500">Interes convenio</p>
            <p className="text-lg font-semibold text-gray-900">{formatCurrency(totals?.interesNuevo)}</p>
          </div>
          <div className="p-3 rounded-lg bg-gray-50 border">
            <p className="text-xs text-gray-500">Total a pagar</p>
            <p className="text-lg font-semibold text-purple-700">{formatCurrency(totals?.total)}</p>
          </div>
          <div className="p-3 rounded-lg bg-gray-50 border">
            <p className="text-xs text-gray-500">Valor por cuota</p>
            <p className="text-lg font-semibold text-green-700">{formatCurrency(totals?.valorCuota)}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="modal-label">Numero de cuotas</label>
            <input
              type="number"
              min="1"
              name="cuotas_convenio"
              value={convenioForm.cuotas_convenio}
              onChange={handleInputChange}
              className="modal-input"
            />
            {errors.cuotas_convenio && <p className="text-xs text-red-600 mt-1">{errors.cuotas_convenio}</p>}
          </div>
          <div>
            <label className="modal-label">Fecha de inicio</label>
            <input
              type="date"
              name="fecha_inicio"
              value={convenioForm.fecha_inicio}
              onChange={handleInputChange}
              className="modal-input"
            />
            {errors.fecha_inicio && <p className="text-xs text-red-600 mt-1">{errors.fecha_inicio}</p>}
          </div>
          <div>
            <label className="modal-label">Frecuencia</label>
            <select
              name="frecuencia"
              value={convenioForm.frecuencia}
              onChange={handleInputChange}
              className="modal-select"
            >
              <option value="">Seleccione</option>
              <option value="semanal">Semanal</option>
              <option value="decenal">Decenal</option>
              <option value="catorcenal">Catorcenal</option>
              <option value="mensual">Mensual</option>
            </select>
            {errors.frecuencia && <p className="text-xs text-red-600 mt-1">{errors.frecuencia}</p>}
          </div>
          <div>
            <label className="modal-label">Tasa de interes convenio (%)</label>
            <input
              type="number"
              min="1"
              max="5"
              step="0.1"
              name="tasa_interes"
              value={convenioForm.tasa_interes}
              onChange={handleInputChange}
              className="modal-input"
            />
            {errors.tasa_interes && <p className="text-xs text-red-600 mt-1">{errors.tasa_interes}</p>}
          </div>
        </div>

        <div className="mt-4 space-y-2">
          <label className="flex items-center text-sm text-gray-800 gap-2">
            <input
              type="checkbox"
              name="solo_capital"
              checked={convenioForm.solo_capital}
              onChange={handleInputChange}
              className="h-4 w-4 text-purple-600 border-gray-300 rounded"
            />
            Trabajar solo sobre capital pendiente (excluye interes actual)
          </label>
          <label className="flex items-center text-sm text-gray-800 gap-2">
            <input
              type="checkbox"
              name="excluir_mora"
              checked={convenioForm.excluir_mora}
              onChange={handleInputChange}
              className="h-4 w-4 text-purple-600 border-gray-300 rounded"
            />
            Excluir la mora de todas las cuotas vencidas
          </label>
        </div>

        <div className="mt-4">
          <label className="modal-label">
            Observaciones (opcional)
          </label>
          <textarea
            name="observaciones"
            value={convenioForm.observaciones}
            onChange={handleInputChange}
            className="modal-textarea"
            rows="2"
            maxLength="255"
          ></textarea>
        </div>

        {errors.generalConvenio && (
          <p className="text-sm text-red-600 mt-2">{errors.generalConvenio}</p>
        )}

        <div className="modal-actions mt-6">
          <button
            onClick={onClose}
            className="btn-modal-neutral"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmAction}
            className="btn-modal-primary"
          >
            Registrar Convenio
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConvenioPrestamoModal;
